module.exports = __webpack_public_path__ + "static/img/introduction-environmental-strategy-engine-innovation.7dd76e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-environmental-strategy-engine-innovation.jpg
// module id = J9ne
// module chunks = 0